const TECHNICAL_ERROR_PATTERN = /(?:https?:\/\/|\b(?:GET|POST|PUT|PATCH|DELETE)\b|\b(?:HTTP|SQL|Axios|FetchError|TypeError|ReferenceError|SyntaxError|Error:)\b|\b(?:ECONN|ENOTFOUND|ETIMEDOUT|ERR_[A-Z_]+)\b|\bat\s+\S+\s*\(|\/api\/|\\\\|stack|network|timeout|localhost|\d{3}\s*(?:error|错误))/i;

/**
 * 仅向用户展示明确的中文业务校验信息，屏蔽接口、网络和堆栈等技术异常。
 */
export const getUserFacingErrorMessage = (error: unknown, fallback: string): string => {
  if (!(error instanceof Error)) return fallback;

  const message = error.message.trim();
  if (
    !message ||
    message.length > 160 ||
    TECHNICAL_ERROR_PATTERN.test(message) ||
    !/[\u4e00-\u9fff]/.test(message)
  ) {
    return fallback;
  }

  return message;
};
